import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'; // For AES encryption

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private secretKey: string = 'GIT-VMS'; // Replace with your actual secret key

  constructor() { }

// Helper function to convert ASCII-converted number to Base36
private toBase36(num: number): string {
  const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let base36 = '';
  while (num > 0) {
    const rem = num % 36;
    base36 = alphabet[rem] + base36;
    num = Math.floor(num / 36);
  }
  return base36 || '0';
}

// Helper function to convert Base36 back to decimal number
private fromBase36(base36: string): number {
  return parseInt(base36, 36);
}
  // Encryption function: Convert the string into an 8-digit number
  encryptToNumber(input: string): string {
   // Convert each character to ASCII and concatenate into a single number string
   let asciiNumberString = '';
   for (let char of input) {
     asciiNumberString += char.charCodeAt(0);
   }

   // Convert concatenated ASCII number string to an actual number
   const asciiNumber = parseInt(asciiNumberString, 10);

   // Convert this large number to Base36
   return this.toBase36(asciiNumber);
  }

// Decrypt the numeric value back to the original string
decryptFromNumber(input: string): string {
  // Convert the Base36 string back to the large ASCII number
  const asciiNumber = this.fromBase36(input);

  // Convert the number back to a string
  const asciiNumberString = asciiNumber.toString();

  // Split every 2 characters to retrieve original ASCII codes
  let decrypted = '';
  for (let i = 0; i < asciiNumberString.length; i += 2) {
    const asciiCode = parseInt(asciiNumberString.substr(i, 2), 10);
    decrypted += String.fromCharCode(asciiCode);
  }

  return decrypted;
}


// Simple encoding method (Base64)
encrypt(value: string): string {
  return btoa(value);  // Convert to Base64 encoding
}

// Simple decoding method (Base64)
decrypt(value: string): string {
  return atob(value);  // Convert from Base64 encoding
}
   
}
